import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Fetch service item categories for a specific restaurant
 * @param {number} restaurantId - The restaurant ID
 * @param {string} language - The language parameter (default: 'en')
 * @param {number} cateringId - The catering ID parameter (optional)
 * @returns {Promise<Array>} - Response data from the API
 */
export const getRestaurantItemsCategories = async (restaurantId, language = "en", cateringId = null) => {
  try {
    let endpoint = `${API_ENDPOINTS.RESTAURANT}/${restaurantId}/service-item-categories?language=${language}`;
    
    // Add catering_id parameter if provided
    if (cateringId) {
      endpoint += `&catering_id=${cateringId}`;
    }
    
    console.log("Fetching categories from endpoint:", endpoint);
    
    const response = await apiClient.get(endpoint);
    
    console.log("Categories API full response:", response);
    console.log("Categories API response.data:", response.data);
    console.log("Categories API response.data.data:", response.data.data);
    
    return response.data.data;
  } catch (error) {
    console.error("Categories API error:", error);
    handleApiError(error);
    throw error;
  }
}; 